import { Component, OnInit } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Subscription } from 'rxjs'
import { AppService } from 'src/app/server/app.service'
import { environment } from "../../../environments/environment"
import { LoginService } from 'src/app/pages/login/login.service';
import { Passport } from 'src/app/shared/security/passport.model';
import { AuthService } from 'src/app/shared/security/auth.service';
import { Router } from '@angular/router';
import { JwtTokenService } from 'src/app/shared/security/jwt.service';
import { FileModel } from 'src/app/shared/file/file.model';
import { FileService } from 'src/app/shared/file/file.service';
import { FormGroup, FormBuilder } from '@angular/forms';

export let isDebugMode = environment.isDebugMode

@Component({
  selector: 'flow-starter-header',
  templateUrl: './starter-header.component.html',
  styleUrls: ['./starter-header.component.scss'],
  host: { "(window:resize)": "onResize($event)" }
})
export class StarterHeaderComponent implements OnInit {

  private subscriptions: Subscription[] = []
  sideBarExpand: boolean = false
  expandPanelUser: boolean = false
  windowWidth: number = window.innerWidth
  windowHeight: number = window.innerHeight
  mobile: boolean = false;
  loggedIn: boolean = false;
  passport: Passport
  file: FileModel


  constructor(
    private appService: AppService,
    private auth: AuthService,
    private jwt: JwtTokenService,
    private loginService: LoginService,
    private router: Router,
    private fileService: FileService,
    private fb: FormBuilder
  ) {
    this.loggedIn = this.auth.loggedIn
    //this.file.src = "assets/img/avatar.png"

    if (this.loggedIn) {

      this.appService.getPassport().subscribe(
        passport => {
          this.passport = passport
          if (this.passport.register[0].fileid) {

            /*
            this.fileService.get(this.passport.register[0].fileid.toString()).subscribe(
              data => {
                this.file = data.recordsets[1][0]
                this.getImage(this.file)
              }
            )
            */

          }
        }
      )


    }

  }
  ngOnInit() {
    isDebugMode ? console.log(`ngOnInit()`) : undefined
    if (this.windowWidth < 565) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }
    this.subscriptions.push()
  }
  ngOnDestroy() {
    isDebugMode ? console.log(`ngOnDestroy()`) : undefined
    this.subscriptions.forEach(sub => sub.unsubscribe())
  }
  toggleSidebar(): void {
    this.sideBarExpand = !this.sideBarExpand
    this.appService.eventSideBarExpand.emit(this.sideBarExpand)
  }
  getImage(file: FileModel) {
    var imageObj = new Image();
    if (file.extension == 'png' || file.extension == 'jpg' || file.extension == 'gif') {
      imageObj.src = 'data:image/png;base64,' + this.base64ArrayBuffer(file.filedata.data)
    } else {
      imageObj.src = `../../../../assets/img/avatar.png`
    }
    file.src = imageObj.src
  }
  base64ArrayBuffer(arrayBuffer) {

    var base64 = ''
    var encodings = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'

    var bytes = new Uint8Array(arrayBuffer)
    var byteLength = bytes.byteLength
    var byteRemainder = byteLength % 3
    var mainLength = byteLength - byteRemainder

    var a, b, c, d
    var chunk

    // Main loop deals with bytes in chunks of 3
    for (var i = 0;i < mainLength;i = i + 3) {
      // Combine the three bytes into a single integer
      chunk = (bytes[i] << 16) | (bytes[i + 1] << 8) | bytes[i + 2]

      // Use bitmasks to extract 6-bit segments from the triplet
      a = (chunk & 16515072) >> 18 // 16515072 = (2^6 - 1) << 18
      b = (chunk & 258048) >> 12 // 258048   = (2^6 - 1) << 12
      c = (chunk & 4032) >> 6 // 4032     = (2^6 - 1) << 6
      d = chunk & 63               // 63       = 2^6 - 1

      // Convert the raw binary segments to the appropriate ASCII encoding
      base64 += encodings[a] + encodings[b] + encodings[c] + encodings[d]
    }

    // Deal with the remaining bytes and padding
    if (byteRemainder == 1) {
      chunk = bytes[mainLength]

      a = (chunk & 252) >> 2 // 252 = (2^6 - 1) << 2

      // Set the 4 least significant bits to zero
      b = (chunk & 3) << 4 // 3   = 2^2 - 1

      base64 += encodings[a] + encodings[b] + '=='
    } else if (byteRemainder == 2) {
      chunk = (bytes[mainLength] << 8) | bytes[mainLength + 1]

      a = (chunk & 64512) >> 10 // 64512 = (2^6 - 1) << 10
      b = (chunk & 1008) >> 4 // 1008  = (2^6 - 1) << 4

      // Set the 2 least significant bits to zero
      c = (chunk & 15) << 2 // 15    = 2^4 - 1

      base64 += encodings[a] + encodings[b] + encodings[c] + '='
    }

    return base64
  }
  onResize(event) {
    isDebugMode ? console.info('onResize()') : undefined
    this.windowWidth = event.target.innerWidth
    this.windowHeight = event.target.innerHeight

    if (this.windowWidth < 565) {
      this.mobile = true;
    } else {
      this.mobile = false;
    }

  }
  login() {
    this.loginService.handleLogin("/home")
  }
  logout() {
    this.loginService.handleLogout()
    this.router.navigate(["/login"])
  }
  togglePanel() {
    this.expandPanelUser = !this.expandPanelUser
  }


}
